import React from 'react';
import {Typography} from "@mui/material";

type GroupSummariesCardItemValueProps = React.ComponentPropsWithoutRef<'span'>;

/**
 * Styled typography component to be used for value text in the group summaries series of components
 * @constructor
 */
const GroupSummariesCardItemValue = (props: GroupSummariesCardItemValueProps) => {
  return <Typography variant={'body2'} {...props} />
}

export { GroupSummariesCardItemValue };
